import { h } from 'vue'
import { SafeIdMixin } from '../../mixins/safeid.mixin'

export default {
  name: 'j-radio-group',
  mixins: [SafeIdMixin],
  props: {
    id: String,
    label: String,
    name: String,
    options: {
      type: Array,
      default: () => [
        { text: 'Radio 1', value: 'r1' }
        , { text: 'Radio 2', value: 'r2' }
      ]
    },
    // The $prop(s) its type is not defined has the init value though,
    // it will be 'undefined' until the first time new/init value is
    // assigned/processed.
    modelValue: {
      type: [String, Array, Boolean],
      default: null
    },
    // default value
    checked: { type: [String, Array, Boolean], default: false }
  },
  emits: ['update:modelValue'],
  data: () => ({
    localId_: null
  }),
  mounted() {
    // Initialize with checked value if modelValue is not set
    if (this.checked !== false && this.modelValue === null) {
      this.$emit('update:modelValue', this.checked)
    }
  },
  methods: {
    // Radio Groups can only have a single value, so determining if checked is simple
    isChecked(optionValue) {
      return this.modelValue === optionValue;
    },
    handleChange(event) {
      const { value } = event.target;
      this.$emit('update:modelValue', value);
    }
  },
  render() {
    return (
      <div class='v-col wrap__option_group'>
        <span class='label'>{this.label}</span>
        <div class='option_group'>
          { this.options.map((option, idx) => {
              const uid = this.safeId(`_JRG_option_${idx}_`,'id')
              return (
                <label for={uid} key={uid}>
                <input
                  id={uid}
                  name={this.name}
                  type="radio"
                  value={option.value}
                  checked={this.isChecked(option.value)}
                  onChange={this.handleChange}
                />
                {option.text}
              </label>
              )
            })
          }
        </div>
      </div>
    )
  }
}
